var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import { useThemeColor } from "./use-theme-color";
import { camelCase, compact } from "lodash";
import { useColorInfo } from "./use-color-info";
import { color } from "@shapeable/theme";
import { useTheme } from "./use-theme";
export var useComponentColor = function useComponentColor(options) {
  var cls = options.cls,
      prop = options.prop,
      sub = options.sub,
      fallbacks = options.fallbacks,
      invertedFallbacks = options.invertedFallbacks,
      debug = options.debug;
  var theme = useTheme();
  var colorInfo = useColorInfo();
  var isInverted = options.isInverted || colorInfo.isInverted; // if color is provided, we always just want that, but it must be run through theme color too.

  if (prop) {
    return color({
      theme: theme
    }, prop);
  }

  var keys = compact(__spreadArray([], __read(isInverted ? __spreadArray([cls.invertedColor(sub)], __read(invertedFallbacks || []), false) : __spreadArray([cls.color(sub)], __read(fallbacks || []), false)), false));

  if (debug) {
    console.log('useComponentColor keys', debug === true || debug === 'camel' ? keys.map(camelCase) : keys);
  }

  return useThemeColor.apply(void 0, __spreadArray([], __read(keys), false));
};